import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { UserUIModel } from '@examdojo/models/user';
import { ProfileAvatarComponent } from '@examdojo/user';

@Component({
  selector: 'dojo-sidebar-profile-link',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatTooltip, ProfileAvatarComponent],
  templateUrl: './sidebar-profile-link.component.html',
  styleUrl: './sidebar-profile-link.component.scss',
  host: { class: 'block' },
})
export class SidebarProfileLinkComponent {
  readonly user = input.required<UserUIModel>();
  readonly settingsRoute = input.required<string>();
  readonly clicked = output<void>();

  onClick() {
    this.clicked.emit();
  }
}
